export default __webpack_public_path__ + "static/media/rosalespereira.b4b398cf.jpg";